import { getClientConfig } from '../config/getClientConfig';

const { theme: defaultTheme } = getClientConfig();

/**
 * @param {PictureImages} urls - The URLs of the images for different breakpoints.
 * @param {ElementType} elmName - The element type for which the image properties are
 * @return {PictureImages}
 */
const getImageProperties = (urls, elmName) => {
  /**
   * @constant
   * @type {PictureImages}
   */
  const imgUrlsWithProps = {
    xxl: undefined,
    xl: '',
    lg: undefined,
    md: '',
    xs: '',
  };

  Object.entries(urls).forEach(([breakpoint, imageId]) => {
    let isSafari;

    if (typeof window !== 'undefined') {
      // In case it's Safari we use the fallback 'source' image format instead of webp
      isSafari = /^((?!chrome|android).)*safari/i.test(
        window.navigator.userAgent.toLowerCase(),
      );
    }

    if (imageId && breakpoint) {
      imgUrlsWithProps[breakpoint] = `${imageId}${
        defaultTheme.imgPropertiesMapFn(isSafari)[elmName]?.[breakpoint]
      }`;
    }
    return true;
  });

  return imgUrlsWithProps;
};

export default getImageProperties;
